import React, { useState, useEffect } from 'react';
import { Col, Form, Button, Row } from 'react-bootstrap';

const InboxOutboxFilters = ({ searchParams, setSearchParams = () => { }, fields = [], clearSearchParams = () => { } } = {}) => {
	const modeOfTransmissionOptions = [
		"SMS",
		"Email",
		"Fax",
		"Mail",
		"Upload",
		"Other",
	];
	const statusOptions = [
		"Received",
		"Sent",
		"Pending",
		"Completed",
	];

	let defaultFilters = {
		sender: "",
		mode_of_transmission: "",
		recipient: "",
		claimant: "",
		recieved_start_date: "",
		recieved_end_date: "",
		status: "",
	};
	const [formData, setFormData] = useState({
		sender: searchParams?.sender || null,
		mode_of_transmission: searchParams?.mode_of_transmission || null,
		recipient: searchParams?.recipient || null,
		claimant: searchParams?.claimant || null,
		recieved_start_date: searchParams?.recieved_start_date || null,
		recieved_end_date: searchParams?.recieved_end_date || null,
		status: searchParams?.status || null,
	});

	// Clear Filters
	const clearFilters = () => {
		setFormData(defaultFilters);
		clearSearchParams();
	};

	const onSubmit = async (e) => {
		e.preventDefault();
		setSearchParams(formData);
	};

	useEffect(() => {
		setFormData({
			sender: searchParams?.sender || null,
			mode_of_transmission: searchParams?.mode_of_transmission || null,
			recipient: searchParams?.recipient || null,
			claimant: searchParams?.claimant || null,
			recieved_start_date: searchParams?.recieved_start_date || null,
			recieved_end_date: searchParams?.recieved_end_date || null,
			status: searchParams?.status || null,
		});
	}, [searchParams]);

	return (
		<Form noValidate onSubmit={onSubmit} className="row flex-between-center px-2 py-3 my-3 border bg-100 mx-2">
			<Row>
				<Col>
					<h5>Filters</h5>
				</Col>
			</Row>

			<Row>
				{
					fields.includes('sender') &&
					<Col>
						<Form.Group controlId="sender">
							<Form.Label>Sender</Form.Label>
							<Form.Control
								className={`${searchParams?.sender ? "bg-soft-info" : ""}`}
								size="sm"
								type="text"
								placeholder="Sender"
								name="sender"
								value={formData.sender}
								onChange={(e) => setFormData({ ...formData, sender: e.target.value })}
							/>
						</Form.Group>
					</Col>
				}

				{
					fields.includes("mode_of_transmission") &&
					<Col>
						<Form.Group controlId="mode_of_transmission">
							<Form.Label>Mode of Transmission</Form.Label>
							<Form.Select
								className={`${searchParams?.mode_of_transmission ? "bg-soft-info" : ""}`}
								size="sm"
								aria-label="Mode of Transmission"
								name="mode_of_transmission"
								value={formData.mode_of_transmission}
								onChange={(e) =>
									setFormData({ ...formData, mode_of_transmission: e.target.value })
								}
							>
								<option value="">All</option>
								{modeOfTransmissionOptions.map((option) => (
									<option key={option} value={option}>
										{option}
									</option>
								))}
							</Form.Select>
						</Form.Group>
					</Col>
				}

				{
					fields.includes('recipient') &&
					<Col>
						<Form.Group controlId="recipient">
							<Form.Label>Recipient</Form.Label>
							<Form.Control
								className={`${searchParams?.recipient ? "bg-soft-info" : ""}`}
								size="sm"
								type="text"
								placeholder="Recipient"
								name="recipient"
								value={formData.recipient}
								onChange={(e) => setFormData({ ...formData, recipient: e.target.value })}
							/>
						</Form.Group>
					</Col>
				}

				{
					fields.includes('claimant') &&
					<Col>
						<Form.Group controlId="claimant">
							<Form.Label>Claimant</Form.Label>
							<Form.Control
								className={`${searchParams?.claimant ? "bg-soft-info" : ""}`}
								size="sm"
								type="text"
								placeholder="Claimant"
								name="claimant"
								value={formData.claimant}
								onChange={(e) => setFormData({ ...formData, claimant: e.target.value })}
							/>
						</Form.Group>
					</Col>
				}
			</Row>
			<Row>
				{
					fields.includes('recieved_start_date') &&
					<Col>
						<Form.Group controlId="recieved_start_date">
							<Form.Label>Recieved Start Date</Form.Label>
							<Form.Control
								className={`${searchParams?.recieved_start_date ? "bg-soft-info" : ""}`}
								size="sm"
								type="date"
								placeholder="Recieved Start Date"
								name="recieved_start_date"
								value={formData.recieved_start_date}
								onChange={(e) =>
									setFormData({ ...formData, recieved_start_date: e.target.value })
								}
							/>
						</Form.Group>
					</Col>
				}

				{
					fields.includes('recieved_end_date') &&
					<Col>
						<Form.Group controlId="recieved_end_date">
							<Form.Label>Recieved End Date</Form.Label>
							<Form.Control
								className={`${searchParams?.recieved_end_date ? "bg-soft-info" : ""}`}
								size="sm"
								type="date"
								placeholder="Recieved End Date"
								name="recieved_end_date"
								value={formData.recieved_end_date}
								onChange={(e) =>
									setFormData({ ...formData, recieved_end_date: e.target.value })
								}
							/>
						</Form.Group>
					</Col>
				}

				{
					fields.includes('status') &&
					<Col>
						<Form.Group controlId="status">
							<Form.Label>Status</Form.Label>
							<Form.Select
								className={`${searchParams?.status ? "bg-soft-info" : ""}`}
								size="sm"
								aria-label="Status"
								name="status"
								value={formData.status}
								onChange={(e) => setFormData({ ...formData, status: e.target.value })}
							>
								<option value="">All</option>
								{statusOptions.map((option) => (
									<option key={option} value={option}>
										{option}
									</option>
								))}
							</Form.Select>
						</Form.Group>
					</Col>
				}
			</Row>
			<Row>
				{
					fields.length > 0 && (
						<>
							<Col>
								<div className="float-end">
									<Button variant="primary" type="submit" className="mt-4">
										Apply Filters
									</Button>
									{
										JSON.stringify(searchParams) && (
											<>
												{' '}
												<Button
													variant="outline-danger"
													type="button"
													className="mt-4"
													onClick={() => {
														clearFilters();
													}}
												>
													Clear Filters
												</Button>
											</>
										)
									}
								</div>
							</Col>
						</>
					)
				}
			</Row>
		</Form >
	);
};

export default InboxOutboxFilters;
